import useTranslate from "@default/hooks/use-translate";
import { useSolrContext } from "@e-fork/solr";
import { flatten } from "lodash";
import React from "react";
import Settings from "@default/assets/ui/settings.svg?url";
import classNames from "classnames";
import DashedBorder from "@default/general-components/dashed-border";

const FilterModalToggle = ({ onClick, label, excludeFromCount = [] }) => {
  const { currentFilters } = useSolrContext();
  const _t = useTranslate();

  let filterCount = 0;
  if (currentFilters) {
    const filterValues = Object.entries(currentFilters)
      .filter(([key]) => !excludeFromCount.includes(key))
      .map(([, values]) => values);
    if (filterValues.length) {
      filterCount = flatten(filterValues)?.length;
    }
  }

  return (
    <button
      className="toggle-filter-overlay filter-control-element sticky-top"
      onClick={onClick}
      aria-label={`${_t("accessibility.open_modal")} ${_t("filter")}`}
    >
      <DashedBorder />
      <img src={Settings} alt={"Settings"} />
      <div
        className={classNames({
          "font-style-change": true,
          active: filterCount > 0,
        })}
      >
        <span className="highlighted">
          {label}
          {!!filterCount && <span>({filterCount})</span>}
        </span>
        <span className="standard">
          {label}
          {!!filterCount && <span>({filterCount})</span>}
        </span>
      </div>
    </button>
  );
};

export default FilterModalToggle;
